import { useEffect, useRef } from "react"

// Scrollt beim Mount nach ganz oben – auch im Cross-Site-iframe im Shop.
//
// Die App läuft als iframe-Embed: Der Parent sized den iframe per
// `iframe-height`-postMessage (siehe IframeHeightSender) auf die volle
// Inhaltshöhe, d.h. der iframe selbst scrollt nicht – der Parent scrollt.
// Nach einer Client-Navigation (z.B. Footer-Link -> /faq) bringt ein simples
// window.scrollTo im iframe daher nichts; der Parent bleibt dort stehen, wo
// geklickt wurde.
//
// Cross-origin darf der iframe den Parent nicht direkt scrollen
// (window.parent.scrollTo ist blockiert). Der Browser scrollt aber ein
// *fokussiertes* Element in Sicht – über Frame-Grenzen hinweg. Wir
// fokussieren deshalb ein unsichtbares Ziel ganz oben, was den Parent an den
// iframe-Anfang scrollt.
export default function ScrollParentToTop() {
	const ref = useRef<HTMLSpanElement>(null)

	useEffect(() => {
		// Standalone (nicht eingebettet): normaler Scroll reicht.
		if (window.parent === window) {
			window.scrollTo(0, 0)
			return
		}
		// Nach dem ersten Frame fokussieren, wenn Layout/iframe-Resize gesetzt sind,
		// damit die Zielposition (Seitenanfang) stimmt.
		const id = requestAnimationFrame(() => ref.current?.focus({ preventScroll: false }))
		return () => cancelAnimationFrame(id)
	}, [])

	return <span ref={ref} tabIndex={-1} className="outline-none" />
}
